
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^8(47|66)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
